<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    @click:outside="onClose()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="$config.isShowEncrypted"
        :color="taskListProps.securityLevelId > 2 ? 'purple' : 'info'"
        outlined
        small
        class="mx-2"
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('eDocInternal.encryptedFileViewerStaff2') }}
      </v-btn>
    </template>
    <v-card>
      <div
        width="100%"
        class="pa-5"
      >
        <s-add-encrypted-staff-2
          ref="addEncryptedStaffRef"
          :opener-list="taskListProps.openerList"
          :new-openers-euid.sync="newOpenersEuid"
          :new-openers-obj.sync="newOpenersObj"
        />
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="loading"
          color="primary"
          @click="onSubmit()"
        >
          {{ $t('outbox.add') }}
        </v-btn>
        <v-btn
          :loading="loading"
          @click="onClose()"
        >
          {{ $t('Text.Cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { encryptMethod } from '@/mixins/encryptMethod'
import { taskMethod } from '@/mixins/taskMethod'
import workflowApi from '@/api/workflow/workflow'
import { globalModule } from '@/store/moduleName'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'
import SAddEncryptedStaff2 from './SAddEncryptedStaff2.vue'

export default {
  components: {
    SAddEncryptedStaff2
  },
  mixins: [taskMethod, encryptMethod],
  props: {
    task: {
      type: Object,
      required: true
    },
    taskListProps: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      newOpenersEuid: [],
      newOpenersObj: [], // for checking opener's public key is generated or not
      dialog: false,
      loading: false
    }
  },
  computed: {
  },
  watch: {
    dialog: function (val) {
      if (val) {
        this.resetFileKey(this.task)
      }
    },
    newOpenersObj: {
      handler: async function (val) {
        await this.checkAndShowNoKeyPairUser(val)
      }
    }
  },
  methods: {
    momentWithHyphen: momentWithHyphen,
    onClose () {
      this.$refs.addEncryptedStaffRef.clear()
      this.newOpenersEuid = []
      this.newOpenersObj = []
      this.dialog = false
    },
    async onSubmit () {
      if (isArrayEmptyOrNull(this.newOpenersEuid)) {
        this.onClose()
        return
      }

      this.loading = true
      if (await this.checkAndShowNoKeyPairUser(this.newOpenersObj)) {
        this.loading = false
        return false
      }
      let body = []
      let newOpenerKeys = await this.buildEncryptedOpenerData(this.newOpenersEuid)
      for (let i = 0; i < this.task.formAttribute.attachmentList.length; i++) {
        const e = this.task.formAttribute.attachmentList[i]
        if (!isArrayEmptyOrNull(e.driveFileOpenerList)) {
          const o = e.driveFileOpenerList[0]
          newOpenerKeys.forEach(opener => {
            body.push({
              docCode: o.docCode,
              keyPairId: opener.keyPairId,
              modifiedByEuid: this.myEuid,
              openerEntityId: this.myEntityId,
              openerEuid: opener.euid,
              openerKey: opener.openerKey
            })
          })
        }
      }

      workflowApi.insertDriveFileOpenerKey(resp => {
        this.loading = false
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.onClose()
          this.$emit('submitSuccess')
        }
      }, body)
    }
  }
}
</script>
